import { render } from "./ProductCompareButton.vue?vue&type=template&id=25a5563f"
import script from "./ProductCompareButton.vue?vue&type=script&lang=js"
export * from "./ProductCompareButton.vue?vue&type=script&lang=js"

import "./ProductCompareButton.vue?vue&type=style&index=0&id=25a5563f&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__